import { Box, Typography } from "@mui/material";

import CreditPacks from "features/Settings/AddOns/AddOnsCredits/CreditPacks";
import CreditsDescription from "features/Settings/AddOns/AddOnsCredits/CreditsDescription";

import styles from "./styles";

const CreditsLimitView = () => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.intro}>
        <Typography sx={styles.title}>You're out of AI credits</Typography>
        <CreditsDescription />
      </Box>
      <CreditPacks />
    </Box>
  );
};

export default CreditsLimitView;
